
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

interface ColorSettingsProps {
    colors: { [key: string]: string };
    onColorChange: (colorName: string, value: string) => void;
}

const colorLabels: { [key: string]: string } = {
    primary: 'اللون الأساسي',
    secondary: 'اللون الثانوي',
    accent: 'لون التمييز',
    text: 'لون النص',
    background: 'لون الخلفية',
};

const presets: { name: string; colors: { [key: string]: string } }[] = [
    { name: '🌙 ذهبي فاخر', colors: { primary: '#1a1a2e', secondary: '#16213e', accent: '#d4a853', text: '#f0e6d3', background: '#0f0f23' } },
    { name: '👑 أزرق ملكي', colors: { primary: '#1e3a5f', secondary: '#0d2137', accent: '#4fc3f7', text: '#e8f4fd', background: '#0a1929' } },
    { name: '🌿 أخضر طبيعي', colors: { primary: '#1b4332', secondary: '#2d6a4f', accent: '#95d5b2', text: '#f0fdf4', background: '#0b2618' } },
    { name: '🌸 وردي أنيق', colors: { primary: '#4a1942', secondary: '#6b2fa0', accent: '#f48fb1', text: '#fce4ec', background: '#2a0e27' } },
    { name: '⚡ رمادي عصري', colors: { primary: '#2d3436', secondary: '#636e72', accent: '#00cec9', text: '#dfe6e9', background: '#1e2425' } },
];

export function ColorSettings({ colors, onColorChange }: ColorSettingsProps) {
    const applyPreset = (preset: typeof presets[0]) => {
        Object.entries(preset.colors).forEach(([key, value]) => {
            onColorChange(key, value);
        });
    };

    return (
        <div className="space-y-5">
            <div>
                <Label className="text-xs text-muted-foreground mb-2 block">قوالب ألوان جاهزة</Label>
                <div className="grid grid-cols-2 gap-2">
                    {presets.map((preset) => (
                        <Button key={preset.name} variant="outline" size="sm" className="text-xs h-auto py-2 justify-start" onClick={() => applyPreset(preset)}>
                            <div className="flex items-center gap-2 w-full">
                                <div className="flex gap-0.5">
                                    {Object.values(preset.colors).slice(0, 3).map((c, i) => (
                                        <div key={i} className="w-3 h-3 rounded-full border" style={{ backgroundColor: c }} />
                                    ))}
                                </div>
                                <span>{preset.name}</span>
                            </div>
                        </Button>
                    ))}
                </div>
            </div>

            <div className="space-y-3">
                {Object.entries(colors).map(([key, value]) => (
                    <div key={key} className="flex items-center justify-between">
                        <Label htmlFor={`${key}-color-picker`}>
                            {colorLabels[key] || key}
                        </Label>
                        <div className="flex items-center gap-2">
                            <Input
                                id={`${key}-color-picker`}
                                type="color"
                                value={value}
                                onChange={(e) => onColorChange(key, e.target.value)}
                                className="p-1 h-8 w-8 cursor-pointer"
                            />
                            <Input
                                value={value}
                                onChange={(e) => onColorChange(key, e.target.value)}
                                className="w-24 text-xs font-mono h-8"
                                placeholder="#000000"
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
